import _ from 'lodash';
import React from 'react';
import postal from 'postal';
import update from 'immutability-helper';
import PropTypes from 'prop-types';

import breakpoints from '../../../shared/breakpoints';
import CampaignSignUpForm from '../../campaigns/campaign-sign-up-form';
import SignInButton from './sign-in-button';

const DEFAULT_CAMPAIGN_HEADER = 'Livewire.<br/>Discover your next investment.';
const DEFAULT_CAMPAIGN_COPY = "Join 120,000 Australians and gain unparalleled access to the trade ideas and investment strategies of Australia's leading investors";
const DEFAULT_CAMPAIGN_LANDING_PAGE_CSS_CLASS = 'campaign-landing-page-default';

function openSignUpModal(event) {
  event && event.preventDefault();

  postal.publish({
    channel: 'commands.campaigns',
    topic: 'present-sign-up-modal',
  });
}

export default class SignUpModal extends React.Component {
  /* Props:
    showImmediately: boolean, if true shows the modal immediately
    redirectTo: string, url to redirect to, default is default sign up redirect path
    campaignHeader: Optional text for Header, allows string & html
    campaignCopy: Optional text for Header, allows string & html
  */

  static propTypes = {
    showImmediately: PropTypes.bool.isRequired,
    redirectTo: PropTypes.string.isRequired,
    campaignHeader: PropTypes.string,
    campaignCopy: PropTypes.string,
    campaignLandingPageCssClass: PropTypes.string,
    showLearnMoreLink: PropTypes.bool,
  }

  static defaultProps = {
    campaignHeader: DEFAULT_CAMPAIGN_HEADER,
    campaignCopy: DEFAULT_CAMPAIGN_COPY,
    campaignLandingPageCssClass: DEFAULT_CAMPAIGN_LANDING_PAGE_CSS_CLASS,
    showLearnMoreLink: true,
  };

  constructor(props, context) {
    super(props, context);

    this.toggleModal = this.toggleModal.bind(this);
    this.dismiss = this.dismiss.bind(this);
    this.present = this.present.bind(this);

    this.state = {
      showModal: false,
      allowClose: true,
      campaignHeader: props.campaignHeader,
      campaignCopy: props.campaignCopy,
      campaignLandingPageCssClass: props.campaignLandingPageCssClass,
      showLearnMoreLink: props.showLearnMoreLink,
      redirectTo: props.redirectTo,
      email: '',
    };
    this.campaignSignUpForm = React.createRef();
  }

  componentDidMount() {
    // NOTE Show the modal when clicking embedded videos within shielded wires,
    // bottom form on wire page, register buttons
    $(document)
      .on(
        'click',
        [
          'button.btn_register',
          '.wire[data-shielded=true] .embedded-video',
          'a[data-id=register-button]',
        ].join(', '),
        event => {
          if ($(event.target).parents('article').length) {
            const linkIsInternal = /^(http?.:\/\/((www|staging)?\.?livewiremarkets\.com|localhost:?[0-9]?[0-9]?[0-9]?[0-9]?\/)|\/).*/.test(event.target.href);

            if (!linkIsInternal) return;
          }

          this.present();
          event.preventDefault();
        },
      );

    // NOTE present immediately if the showImmediately prop is set
    if (this.props.showImmediately) {
      this.present();
    }

    // NOTE invert to make it trigger the first time
    let onMobileOrTablet = !breakpoints.upTo_medium();
    const updateOpacity = () => {
      const currentlyOnMobileOrTablet = breakpoints.upTo_medium();

      if (currentlyOnMobileOrTablet !== onMobileOrTablet) {
        onMobileOrTablet = currentlyOnMobileOrTablet;

        if (onMobileOrTablet) {
          this.$lightLogoImg.hide();
          this.$darkLogoImg.show();
        } else {
          this.$lightLogoImg.show();
          this.$darkLogoImg.hide();
        }
        this.$header.css({
          'background-color': `rgba(255,255,255,${onMobileOrTablet ? 1 : 0})`,
          'border-bottom': `1px solid rgba(255,255,255,${onMobileOrTablet ? 1 : 0})`,
          'box-shadow': `0 2px 5px rgba(0,0,0,${onMobileOrTablet ? 0.5 : 0})`,
        });
        this.forceUpdate();
      }
    };

    $(window).on('resize', _.throttle(() => updateOpacity(), 1000 / 60));
    updateOpacity();

    postal.subscribe({
      channel: 'commands.sign-up',
      topic: 'toggle-sign-up',
      callback: () => this.toggleModal(),
    });
    postal.subscribe({
      channel: 'commands.sign-up',
      topic: 'present',
      callback: data => {
        if (data) {
          this.setState(state => update(state, {
            campaignHeader: { $set: data.campaignHeader || state.campaignHeader },
            campaignCopy: { $set: data.campaignCopy || state.campaignCopy },
            redirectTo: { $set: data.redirectTo || state.redirectTo },
            email: { $set: data.email || state.email },
          }));
        }

        this.present();
      },
    });
    postal.subscribe({
      channel: 'commands.sign-up',
      topic: 'dismiss',
      callback: () => this.dismiss(),
    });
  }

  setShowModalState(showModal) {
    if (this.state.showModal === showModal) return;

    if (showModal) {
      this.showModal();
    } else {
      this.hideModal();
    }

    this.setState({ showModal });

    postal.publish({
      channel: 'events.sign-up',
      topic: showModal ? 'present' : 'dismiss',
    });
  }

  dismiss() {
    this.setShowModalState(false);
  }

  present() {
    this.setShowModalState(true);
  }

  showModal() {
    this.$modal.fadeIn({
      duration: 400,
      complete: () => {
        if (this.state.email) {
          this.campaignSignUpForm.current.prefillEmail(this.state.email);
        }
        this.campaignSignUpForm.current.focusInput();
      },
    });
  }

  hideModal() {
    this.$modal.fadeOut(400);
  }

  toggleModal() {
    this.setShowModalState(!this.state.showModal);
  }

  render() {
    const onMobileOrTablet = breakpoints.upTo_medium();

    return (
      <div ref={el => (this.$modal = $(el))} className="full-screen-modal sign-up-modal">
        <header className="campaign-header" ref={el => (this.$header = $(el))}>
          <div className="header-content">
            <a href="/">
              <img
                src={window.getLivewireAssetPath('livewire-logo-wht.png')}
                id="lightLogoImg"
                alt="Livewire"
                ref={el => (this.$lightLogoImg = $(el))}
              />
              <img
                src={window.getLivewireAssetPath('livewire-logo.png')}
                id="darkLogoImg"
                alt="Livewire"
                ref={el => (this.$darkLogoImg = $(el))}
              />
            </a>
            <div className="already-member">
              {onMobileOrTablet
                ? (
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={openSignUpModal}
                  >
                    Sign up
                  </button>
                )
                : <span>Already a member?</span>}
              <SignInButton />
              {this.state.allowClose && (
                <button type="button" className="close-modal" onClick={this.dismiss}>
                  <span className="pe-7s-close pe-icon-x3" />
                  <span className="sr-only">Close</span>
                </button>
              )}
            </div>
          </div>
        </header>

        <div className="campaign">
          <div className="campaign-content-container">
            <div className={`campaign-landing-page ${this.state.campaignLandingPageCssClass}`}>
              <section className="campaign-sign-up">
                <div className="campaign-content">
                  <section className="campaign-content-col-1 campaign-content-col-text">
                    {/* eslint-disable react/no-danger */}
                    <h2 dangerouslySetInnerHTML={{ __html: this.state.campaignHeader }} />
                    <p dangerouslySetInnerHTML={{ __html: this.state.campaignCopy }} />
                    {/* eslint-enable react/no-danger */}
                    { this.state.showLearnMoreLink && (
                      <p>
                        <a
                          className="btn btn-primary campaign-learn-more"
                          {...(onMobileOrTablet
                            ? { href: '#', onClick: openSignUpModal }
                            : { href: '/company/home' }
                          )}
                        >
                          {onMobileOrTablet ? 'Register free' : 'Learn more'}
                        </a>
                      </p>
                    )}
                  </section>
                  <section className="campaign-content-col-2 campaign-content-col-text">
                    <CampaignSignUpForm
                      showPreHeaderCopy
                      redirectTo={this.state.redirectTo}
                      ref={this.campaignSignUpForm}
                    />
                  </section>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
